export default {
  name: 'dark',
  fontColor: 'hsla(0,0%,100%,.8)',
  secondaryFontColor: '#4E516C',
  lightFontColor: 'hsla(0,0%,100%,.8)',
  purple: '#ba54f5',
  loadingTableColor: '#4E516C',
  loadingTableColorLight: '#5e6182',
  componentborder: 'hsla(0,0%,100%,.15)',
  background: '#1e1e24',
  cardBackgroud: '#27293d',
  cardBorder: '#27293d',

  error: '#f5365c',
  success: '#00bf9a',
  info: '#106EBE',
  warn: '#ff9f89',
  attention: '#ffd472',
  backgroundSecondary: '#353752',
  playerControls: '#353752',
  hover: '#353752',
  selectedPage: '#106EBE',
  skeleton: {
    color: '#333', // #202020
    highlight: '#444',
  },
  menu: {
    fontColor: '#1d253b',
    in: '#3358f4',
    out: '#1D8CF8',
  },
  tooltip: {
    background: '#f5f5f5',
    fontColor: 'rgba(0,0,0,0.85)',
  },
  switch: {
    background: '#4f537b',
    checkedbackground: '#4fbe79',
  },
  checkbox: {
    notselected: 'hsla(0,0%,100%,.8)',
    selected: '#3358f4',
  },
  select: {
    selected: '#3358f4',
    new: '#4E516C',
  },
  table: {
    header: '#353752',
    fontColor: 'hsla(0,0%,100%,.8)',
  },
  notification: {
    new: '#C94F5C',
    empty: '#1e1e24',
  },
  badge: {
    unselected: '#31334d',
    selected: '#3358f4',
  },
  graph: {
    graphAxis: 'rgba(253,93,147,0.1)',
    semplanilha: '#1D8CF8',
    naogravados: '#C94F5C',
    naoconferidos: '#ffd472',
    pendentes: '#ff8a72',
    disponiveiseng: '#1D8CF8',
    gravados: '#02D2B6',
    conferidos: '#07C961',
    aprovado: '#07C961',
    reprovado: '#C94F5C',
    ressalva: '#ffd472',
  },

  datepicker: {
    selected: '#0074d9',
    today: '#4E516C',
  },

  timeline: {
    bar: 'hsla(0,0%,100%,.8)',
    balloon: '#344675',
  },
  button: {
    default: {
      in: '#263148',
      out: '#344675',
      text: '#344675',
    },
    primary: {
      in: '#3358f4',
      out: '#1D8CF8',
      text: '#1D8CF8',
    },
    secondary: {
      in: '#ba54f5',
      out: '#e14eca',
    },
    // done: {
    //   in: '#186869',
    //   out: '#009677',
    // },
    done: {
      in: '#007f96',
      out: '#00e6e9',
    },
    // done: {
    //   in: '#c5e900',
    //   out: '#2f9600',
    // },
    success: {
      in: '#0CB194',
      out: '#07C961',
    },
    warn: {
      in: '#ffd472',
      out: '#ff8a72',
    },
    danger: {
      in: '#f5365c',
      out: '#C94F5C',
    },
    flag: {
      in: 'hsla(0,0%,100%,.8)',
      out: '#344675',
    },
  },

  calendar: {
    chamada: '#00FF7F',
    vinheta: '#87CEFA',
    promocional: '#F57C00',
    chpatrocinada: '#C94F5C',
    apoio: '#FFC107',
    campanha: '#E91E63',
    campanhapatrocinada: '#795548',
    videopatrocinado: '#7C4DFF',
    programete: '#4E516C',
    afinacao: '#ba54f5',
    multiploformato: '#0CB194', // Orientações Exibição
  },

  daytime: {
    manha: '#ab6114',
    tarde: '#c49300',
    noite: '#004c8e',
  },

  flag: {
    indisponivel: '#4E516C',
    nao_autorizado: '#4E516C',
    sem_planilha: '#4E516C',
    inativo: '#4E516C',
    noclosedcaption: '#4E516C',
    exibrede: '#4E516C',
    fade: '#4E516C',
    semCC: '#4E516C',
    semweb: '#4E516C',
    NA: '#4E516C',
    arquivado: '#4E516C',
    autotranscrever: '#2B88D8',
    pendente: '#2B88D8',
    fila_download: '#2B88D8',
    baixando: '#2B88D8',
    emAndamento: '#2B88D8',
    emprocesso: '#2B88D8',
    processando: '#2B88D8',
    avaliacao_eng: '#2B88D8',
    fila_envio: '#2B88D8',
    resetar_senha: '#2B88D8',
    convertendo: '#2B88D8',
    cadastrando: '#2B88D8',
    enviando_exibidor: '#2B88D8',
    enviadaVI: '#2B88D8',
    analisando: '#2B88D8',
    solicitado: '#2B88D8',
    autorizado: '#2B88D8',
    gravado: '#0CB194',
    conferido: '#0CB194',
    processado: '#0CB194',
    aprovado: '#0CB194',
    ingest_manual: '#0CB194',
    ativo: '#0CB194',
    convertido: '#0CB194',
    cadastrado: '#0CB194',
    closedcaption: '#0CB194',
    cadastrada: '#0CB194',
    encapsulada: '#0CB194',
    editada: '#0CB194',
    finalizado: '#0CB194',
    analisado: '#0CB194',
    entregue: '#0CB194',
    ressalva: '#ffd472',
    aprovacao: '#ffd472',
    reprovado_eng: '#C94F5C',
    reprovado: '#C94F5C',
    error: '#C94F5C',
    erro: '#C94F5C',
    erro_envio: '#C94F5C',
    erroconversao: '#C94F5C',
    errocadastro: '#C94F5C',
    alteracao: '#C94F5C',
    naogravado: '#C94F5C',
    reenvio: '#ba54f5',
    edicao: '#ba54f5',
    entreguech: '#007f96',
    // Tipos de Comerciais
    comercial: '#2B88D8',
    base: '#FFC107',
    patrocinio: '#FFC107',
    // Tipos de Chamadas
    chamada: '#388E3C',
    vinheta: '#3358f4',
    promocional: '#F57C00',
    chpatrocinada: '#C94F5C',
    apoio: '#FFC107',
    campanha: '#E91E63',
    campanhapatrocinada: '#795548',
    videopatrocinado: '#7C4DFF',
    programete: '#4E516C',
    afinacao: '#ba54f5',
    // Tipos de Midias
    chjorn: '#388E3C',
    rede: '#3358f4',
    pgrede: '#3358f4',
    blocopolitico: '#ba54f5',
    optativo: '#F57C00',
    // Setores
    programacao: '#ff8a72',
    jornalismo: '#388E3C',
    cedoc: '#ff8a72',
    marketing: '#ff8a72',
    opec: '#2B88D8',
    promo: '#ba54f5',
    hub: '#ba54f5',
    engenharia: '#ffd472',
    // Tipos de Solicitações de Chamadas
    especiais: '#3358f4',
    pgmlinha: '#ba54f5',
    // Tipos de Solicitações Digital
    g1: '#C94F5C',
    especial: '#FFC107',
    exclusivo: '#ba54f5',
    evento: '#3358f4',
    // Notificação Melhoria do Break
    insight: '#FFC107',
    alerta: '#C94F5C',
    //Telões
    padrao: '#0CB194',
    novacriacao: '#ba54f5',
    outroformato: '#3358f4',
    unico: '#FFC107',
    menor: '#007f96',
    maior: '#2B88D8',
  },
  // flag: {
  //   disabled: '#4E516C',
  //   // indisponivel: '#4E516C',
  //   // nao_autorizado: '#4E516C',
  //   // sem_planilha: '#4E516C',
  //   // inativo: '#4E516C',
  //   // noclosedcaption: '#4E516C',
  //   // exibrede: '#4E516C',
  //   // fade: '#4E516C',
  //   // semCC: '#4E516C',
  //   // semweb: '#4E516C',
  //   // NA: '#4E516C',
  //   // arquivado: '#4E516C',
  //   processing: '#2B88D8',
  //   // autotranscrever: '#2B88D8',
  //   // pendente: '#2B88D8',
  //   // fila_download: '#2B88D8',
  //   // baixando: '#2B88D8',
  //   // emAndamento: '#2B88D8',
  //   // emprocesso: '#2B88D8',
  //   // processando: '#2B88D8',
  //   // avaliacao_eng: '#2B88D8',
  //   // fila_envio: '#2B88D8',
  //   // resetar_senha: '#2B88D8',
  //   // convertendo: '#2B88D8',
  //   // cadastrando: '#2B88D8',
  //   // enviando_exibidor: '#2B88D8',
  //   // enviadaVI: '#2B88D8',
  //   // analisando: '#2B88D8',
  //   ok: '#0CB194',
  //   // gravado: '#0CB194',
  //   // conferido: '#0CB194',
  //   // processado: '#0CB194',
  //   // aprovado: '#0CB194',
  //   // ingest_manual: '#0CB194',
  //   // ativo: '#0CB194',
  //   // convertido: '#0CB194',
  //   // cadastrado: '#0CB194',
  //   // closedcaption: '#0CB194',
  //   // cadastrada: '#0CB194',
  //   // encapsulada: '#0CB194',
  //   // entregue: '#0CB194',
  //   // editada: '#0CB194',
  //   // finalizado: '#0CB194',
  //   // analisado: '#0CB194',
  //   warn: '#ffd472',
  //   // ressalva: '#ffd472',
  //   // aprovacao: '#ffd472',
  //   error: '#C94F5C',
  //   // reprovado_eng: '#C94F5C',
  //   // reprovado: '#C94F5C',
  //   // error: '#C94F5C',
  //   // erro: '#C94F5C',
  //   // erro_envio: '#C94F5C',
  //   // erroconversao: '#C94F5C',
  //   // errocadastro: '#C94F5C',
  //   // alteracao: '#C94F5C',
  //   // naogravado: '#C94F5C',
  //   purple: '#ba54f5',
  //   // reenvio: '#ba54f5',
  //   // edicao: '#ba54f5',
  //   // Tipos de Comerciais
  //   // comercial: '#2B88D8',
  //   yellow: '#FFC107',
  //   // base: '#FFC107',
  //   // patrocinio: '#FFC107',
  //   // Tipos de Chamadas
  //   chamada: '#388E3C',
  //   vinheta: '#3358f4',
  //   promocional: '#F57C00',
  //   chpatrocinada: '#C94F5C',
  //   apoio: '#FFC107',
  //   campanha: '#E91E63',
  //   campanhapatrocinada: '#795548',
  //   videopatrocinado: '#7C4DFF',
  //   programete: '#4E516C',
  //   // Tipos de Midias
  //   chjorn: '#388E3C',
  //   rede: '#3358f4',
  //   pgrede: '#3358f4',
  //   blocopolitico: '#ba54f5',
  //   optativo: '#F57C00',
  //   // Setores
  //   programacao: '#ff8a72',
  //   jornalismo: '#ff8a72',
  //   cedoc: '#ff8a72',
  //   marketing: '#ff8a72',
  //   opec: '#2B88D8',
  //   promo: '#ba54f5',
  //   hub: '#ba54f5',
  //   engenharia: '#ffd472',
  // },
};
